import GraphemeSplitter from "grapheme-splitter"

export function getFirstCharOrEmoji(value: string): string {
  if (value.length === 0) {
    return "" // Return an empty string if the input is empty
  }

  const splitter = new GraphemeSplitter()
  const graphemes = splitter.splitGraphemes(value)

  // Return the first grapheme (which could be a complex emoji or a single character)
  return graphemes.length > 0 ? graphemes[0] : ""
}
